import { Component, ElementRef, QueryList, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { BusyService } from '../../_services/busy.service';

@Component({
  selector: 'app-training-videos',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgFor,
    NgIf,
    NgClass,
    FormsModule,
    MultiSelectModule,
  ],
  templateUrl: './training-videos.component.html',
  styleUrls: ['./training-videos.component.scss'],
})
export class TrainingVideosComponent {
  currentPlayingVideo: HTMLVideoElement | null = null;
  // aboutIntoVideo = 'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
  // aboutThumbnail = 'https://www.chemrobotics.com/assets/images/banner/about-banner.png';
  videoBaseUrl = 'https://www.chemrobotics.com/agropat/uploads/web_videos/';
  videosThumbnailUrl = '';
  trainingvideoList: any = [];
  // aboutVideo: any;
  showMore = false;
  head: any[] = [];
  currentPage: string = 'training';

  totalTrainingVideo: any = 0;
  database: any[] = [];
  selectedDatabase: any[] = [];

  // trainingvideoList: any[] = [
  //   {
  //     title: 'ChemRobotics (AgroPat® / PharmVetPat®)',
  //     description: "ChemRobotics™ “Technical Routes” is a platform dedicated to the agrochemical, pharmaceutical and fine chemical industry, wherein more than 15000 active ingredients processes or routes of synthesis with their intermediates are disclosed. Said intermediate can be searched by their CAS RN. And IUPAC name etc.",
  //     url: 'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4',
  //     thumbnail: 'https://www.chemrobotics.com/assets/images/banner/about-banner.png'
  //   },
  //   {
  //     title: 'ChemRobotics (AgroPat® / PharmVetPat®)',
  //     description: "ChemRobotics™ “Technical Routes” is a platform dedicated to the agrochemical, pharmaceutical and fine chemical industry, wherein more than 15000 active ingredients processes or routes of synthesis with their intermediates are disclosed. Said intermediate can be searched by their CAS RN. And IUPAC name etc.",
  //     url: 'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4',
  //     thumbnail: 'https://www.chemrobotics.com/assets/images/banner/about-banner.png'
  //   },
  //   {
  //     title: 'ChemRobotics (AgroPat® / PharmVetPat®)',
  //     description: "ChemRobotics™ “Technical Routes” is a platform dedicated to the agrochemical, pharmaceutical and fine chemical industry, wherein more than 15000 active ingredients processes or routes of synthesis with their intermediates are disclosed. Said intermediate can be searched by their CAS RN. And IUPAC name etc.",
  //     url: 'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4',
  //     thumbnail: 'https://www.chemrobotics.com/assets/images/banner/about-banner.png'
  //   },
  //   {
  //     title: 'ChemRobotics (AgroPat® / PharmVetPat®)',
  //     description: "ChemRobotics™ “Technical Routes” is a platform dedicated to the agrochemical, pharmaceutical and fine chemical industry, wherein more than 15000 active ingredients processes or routes of synthesis with their intermediates are disclosed. Said intermediate can be searched by their CAS RN. And IUPAC name etc.",
  //     url: 'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4',
  //     thumbnail: 'https://www.chemrobotics.com/assets/images/banner/about-banner.png'
  //   }
  // ];

  constructor(
    private datasearch: DatasearchService,
    private busyService: BusyService
  ) {}

  ngOnInit() {
    this.videosThumbnailUrl = `${this.datasearch.ApiUrl}/uploads/training-thumbnails/`;
    this.getTrainingvideos();
    this.getHeading();
    this.database = [
      { name: 'Agrochemical Database' },
      { name: 'Pharmaceutical Database' },
      { name: 'Specialty Chemical' },
    ];
  }

  getTrainingvideos() {
    this.datasearch.getTrainingvideos().subscribe(
      (res) => {
        if (res && res.success && res.data) {
          // Filter only active training videos
          this.trainingvideoList = res.data.filter((video: any) => video.isActive === true);
          this.trainingvideoList.forEach((video: any) => video.showMore = false);
          this.totalTrainingVideo = this.trainingvideoList.length;
        } else {
          this.trainingvideoList = [];
          this.totalTrainingVideo = 0;
        }
      },
      (err) => {
        console.error('Error loading training videos', err);
        this.trainingvideoList = [];
        this.totalTrainingVideo = 0;
      }
    );
  }

  toggleVideo(index: number) {
    const video = document.getElementById('video-' + index) as HTMLVideoElement;

    if (this.currentPlayingVideo && this.currentPlayingVideo !== video) {
      this.currentPlayingVideo.pause();
    }

    if (video.paused) {
      video.play();
      this.currentPlayingVideo = video;
    } else {
      video.pause();
      this.currentPlayingVideo = null;
    }
  }

  toggleShowMore(video: any) {
    if (video) {
      video.showMore = !video.showMore;
    }
  }

  hasLongDescription(video: any): boolean {
    if (!video || !video.description) {
      return false;
    }
    const plainText = video.description.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    return plainText.length > 250;
  }

  getHeading() {
    this.datasearch.getAllHeadings().subscribe((res) => {
      if (res.success) {
        this.head = res.data.filter(
          (heading: any) => heading.page === this.currentPage
        );
      }
    });
  }
  openLink(url: string) {
    if (url) {
      let trimmed = url.trim();
      if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
        trimmed = 'https://' + trimmed;
      }
      window.open(trimmed, '_blank');
    }
  }

  sortTrainingByDatabase() {
    if (this.selectedDatabase.length > 0) {
      let postdata = this.selectedDatabase;

      this.busyService.busy();
      this.datasearch.findTrainingByDatabase(postdata).subscribe(
        (res: any) => {
          this.busyService.idle();
          // Filter only active training videos
          this.trainingvideoList = res.data.filter((video: any) => video.isActive === true);
          this.trainingvideoList.forEach((video: any) => video.showMore = false);
          this.totalTrainingVideo = this.trainingvideoList.length;
        },
        (errorobj) => {
          this.busyService.idle();
          console.log(errorobj);
        }
      );
    } else {
      this.getTrainingvideos();
    }
  }
}
